import { useMemo } from 'react';
export type IDeviceType = 'desktop' | 'mobile';

export interface IDeviceInfo {
    deviceType: IDeviceType;
    isIOS: boolean;
}

const useDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    const deviceInfo = {
        deviceType: isMobile ? 'mobile' : 'desktop',
        isIOS
    };

    return deviceInfo;
};

export type MobilePlatform = 'ios' | 'android' | 'other';

export const useMobilePlatform = (): MobilePlatform => {
    return useMemo(() => {
        if (typeof navigator === 'undefined') return 'other';

        const ua = navigator.userAgent || navigator.vendor;

        if (/android/i.test(ua)) return 'android';
        if (/iPad|iPhone|iPod/.test(ua)) return 'ios';

        return 'other';
    }, []);
};

// const useDeviceType = (): IDeviceInfo => {
//     const [deviceInfo, setDeviceInfo] = useState<IDeviceInfo>({
//         deviceType: 'desktop',
//         isIOS: false
//     });

//     useEffect(() => {
//         const handleCheckDevice = () => {
//             const userAgent = navigator.userAgent.toLowerCase();
//             const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
//             const isIOS = /iphone|ipad|ipod/.test(userAgent);

//             setDeviceInfo({
//                 deviceType: isMobile ? 'mobile' : 'desktop',
//                 isIOS
//             });
//         };

//         handleCheckDevice();
//         window.addEventListener('resize', handleCheckDevice);
//         return () => {
//             window.removeEventListener('resize', handleCheckDevice);
//         };
//     }, []);

//     return deviceInfo;
// };

export default useDeviceType;
